import React, { useState, useRef, useEffect } from "react";

const DropDownSelector = ({
  label,
  name,
  value,
  options,
  onChange,
  error,
  className,
  isDisplayErrorInLabel = false,
  placeholder = "",
  id,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggle = () => setIsOpen(!isOpen);

  const handleSelect = (option) => {
    onChange({ target: { name, value: option.value } });
    setIsOpen(false);
  };

  const formatLabel = (option) => {
    if (months.includes(option.label)) {
      const monthIndex = months.indexOf(option.label) + 1;
      const formattedNumber =
        monthIndex < 10 ? `( 0${monthIndex} )` : `( ${monthIndex} )`;
      return `${formattedNumber} ${option.label}`;
    }
    return option.label;
  };

  const getDisplayValue = () => {
    const selectedOption = options.find((opt) => opt.value === value);
    if (!selectedOption) return "";
    return formatLabel(selectedOption);
  };

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <label
        className={`block text-[14px] font-normal text-left text-insightful-gray ${
          isDisplayErrorInLabel && "text-red-500"
        } ${className}`}
      >
        {label}
      </label>
      <div
        className="mt-1 relative rounded-md shadow-sm cursor-pointer border-insightful-light-gray border"
        onClick={handleToggle}
      >
        <input
          type="text"
          name={name}
          value={getDisplayValue()}
          placeholder={placeholder}
          readOnly
          className="focus:outline-none focus:ring-insightful-black block w-full px-[20px] py-2 sm:text-sm border-gray-300 rounded-md text-xs"
          id={id}
        />
        <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <svg
            className="h-5 w-5 text-gray-400"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>
      {isOpen && (
        <div className="absolute z-10 mt-1 w-full rounded-md bg-white shadow-lg">
          <ul className="max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
            {options.map((option) => (
              <li
                key={option.value}
                className="text-gray-900 cursor-default text-left select-none relative py-[10px] px-[20px] hover:bg-[#eaeaea] hover:text-black"
                onClick={() => handleSelect(option)}
              >
                {formatLabel(option)}
              </li>
            ))}
          </ul>
        </div>
      )}
      {error && <p className="mt-2 text-xs text-red-600 text-left">{error}</p>}
    </div>
  );
};

export default DropDownSelector;
